/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sanction_Mgr_Max_ExpiryInputs */



/**
* | output |
* | --- |
* | "Maximum 18 months from today" |
*
* @param {Sanction_Mgr_Max_ExpiryInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const sanction_mgr_max_expiry = /** @type {((inputs?: Sanction_Mgr_Max_ExpiryInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sanction_Mgr_Max_ExpiryInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Maximum 18 mois à partir d'aujourd'hui")
	if (locale === "es") return /** @type {LocalizedString} */ ("Máximo 18 meses desde hoy")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Máximo 18 meses a partir de hoje")
	if (locale === "it") return /** @type {LocalizedString} */ ("Massimo 18 mesi da oggi")
	return /** @type {LocalizedString} */ ("Maximum 18 months from today")
});